import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, from } from 'rxjs';
import { map, take } from 'rxjs/operators';

import Survey from 'entity/Survey';
import SurveyController from 'rest/SurveyController';

import { SurveyCardComponent } from '../survey-card/survey-card.component';

import { AnswerService } from './answer.service';

@Injectable({
  providedIn: 'root',
})
export class SurveyService {
  public constructor(
    private dialog: MatDialog,
    private _answerService: AnswerService,
  ) {}

  public open(data: {
    survey: Survey;
    id: string;
    attendeeSurvey?: boolean;
    socialRoomSetId?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }): Observable<any> {
    this._answerService.setId(data.id);
    this._answerService.setSurvey(data.survey);

    const dialogRef = this.dialog.open(SurveyCardComponent, {
      width: '570px',
      height: data.attendeeSurvey ? 'auto' : '600px',
      panelClass: 'survey-modal',
      data: {
        ...data.survey.surveyConfig,
        attendeeSurvey: data.attendeeSurvey,
        socialRoomSetId: data.socialRoomSetId,
      },
      autoFocus: false,
      disableClose: !!data.attendeeSurvey,
    });

    return dialogRef.afterClosed().pipe(
      take(1),
      map((res) => {
        return res;
      }),
    );
  }

  public getSurvey(id: number): Observable<Survey> {
    return from(new SurveyController().getSurvey(id));
  }
}
